import { render, staticRenderFns } from "./appMenuAnno.vue?vue&type=template&id=49350616&scoped=true"
import script from "./appMenuAnno.vue?vue&type=script&lang=js"
export * from "./appMenuAnno.vue?vue&type=script&lang=js"
import style0 from "./appMenuAnno.vue?vue&type=style&index=0&id=49350616&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49350616",
  null
  
)

export default component.exports